// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"f2437cf4","29":"f51ead01"}[chunkId] + ".chunk.js";
};